import styles from "./chip.module.less";

type TChip = {
  text: string | undefined;
};

const Chip = ({ text }: TChip) => {
  if (!text) {
    return null;
  }

  return <p className={[styles.wrapper, "folio-2 uppercase bold", styles.bold].join(" ")}>{text}</p>;
};

export default Chip;
